// @ts-nocheck
import { getFormById, getForms } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import {
    FormModel,
    SetHasAlreadyErrorsHandlerParameter,
} from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";

type Parameter = SetHasAlreadyErrorsHandlerParameter;
type Props = {
    forms: FormModel[];
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateForm: HandlerType = props => {
    const state = props.getState();
    let forms = getForms(state);
    const form = getFormById(state, props.parameter.formId);
    if (form) {
        const _form = cloneDeep(form);

        forms = [...forms];
        _form.hasAlreadyError = form.inputs.some(x => x.error !== "");

        if (_form.hasAlreadyError === form.hasAlreadyError) {
            return;
        }

        const formIndex = findIndex(forms, x => x.id === _form.id);
        forms.splice(formIndex, 1, _form);
    }

    props.forms = forms;

    props.dispatch({
        type: "Foundation/Components/Form/SetInput",
        forms: props.forms,
    });
};

export const DispatchForm: HandlerType = props => {
    props.dispatch({
        type: "Foundation/Components/Form/SetInput",
        forms: props.forms,
    });
};

export const chain = [PopulateForm];

const setHasAlreadyErrors = createHandlerChainRunner(chain, "SetHasAlreadyErrors");

export default setHasAlreadyErrors;
